import _toConsumableArray from "@babel/runtime-corejs3/helpers/esm/toConsumableArray";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2022. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import groupComponentData from './utils';
var BenefitDetails = /*#__PURE__*/_createClass(function BenefitDetails(data) {
  _classCallCheck(this, BenefitDetails);
  this.benefitName = data.benefitName;
  this.benefitReference = data.reference ? data.reference : data === null || data === void 0 ? void 0 : data.benefitReference;
  this.benefit_id = data.benefit_id;
  this.benefitStatus = data === null || data === void 0 ? void 0 : data.benefitStatus;
});
var ComponentPaymentDetails = /*#__PURE__*/_createClass(function ComponentPaymentDetails(data) {
  var _data$type, _data$deliveryMethodT;
  _classCallCheck(this, ComponentPaymentDetails);
  this.amount = data.amount;
  this.adjustmentAmount = data.adjustmentAmount;
  this.coverStartDate = data.coverStartDate;
  this.coverEndDate = data.coverEndDate;
  this.componentName = data.componentName;
  this.typeCode = data === null || data === void 0 ? void 0 : (_data$type = data.type) === null || _data$type === void 0 ? void 0 : _data$type.value;
  this.paymentType = data === null || data === void 0 ? void 0 : (_data$deliveryMethodT = data.deliveryMethodType) === null || _data$deliveryMethodT === void 0 ? void 0 : _data$deliveryMethodT.description;
});
var DeductionDetails = /*#__PURE__*/_createClass(function DeductionDetails(data) {
  var _data$name;
  _classCallCheck(this, DeductionDetails);
  this.amount = data.amount ? data.amount * -1 : (data === null || data === void 0 ? void 0 : data.debitAmount) * -1;
  this.coverStartDate = data.coverStartDate;
  this.coverEndDate = data.coverEndDate;
  this.deductionName = data === null || data === void 0 ? void 0 : (_data$name = data.name) === null || _data$name === void 0 ? void 0 : _data$name.description;
});
var BenefitPaymentDetails = /*#__PURE__*/_createClass(function BenefitPaymentDetails(data) {
  var _data$componentPaymen, _context, _data$componentPaymen2, _context2, _context3, _context4;
  _classCallCheck(this, BenefitPaymentDetails);
  this.amount = data.amount;
  this.paymentTypes = data.paymentTypes;
  this.coverStartDate = data.coverStartDate === undefined && (data === null || data === void 0 ? void 0 : (_data$componentPaymen = data.componentPayments) === null || _data$componentPaymen === void 0 ? void 0 : _data$componentPaymen.length) > 0 && data.componentPayments[0].coverStartDate ? new Date(Math.min.apply(Math, _toConsumableArray(_mapInstanceProperty(_context = data.componentPayments).call(_context, function (item) {
    return item.coverStartDate;
  })))) : data.coverStartDate;
  this.coverEndDate = data.coverEndDate === undefined && (data === null || data === void 0 ? void 0 : (_data$componentPaymen2 = data.componentPayments) === null || _data$componentPaymen2 === void 0 ? void 0 : _data$componentPaymen2.length) > 0 && data.componentPayments[0].coverEndDate ? new Date(Math.max.apply(Math, _toConsumableArray(_mapInstanceProperty(_context2 = data.componentPayments).call(_context2, function (item) {
    return item.coverEndDate;
  })))) : data.coverEndDate;
  var benefit = new BenefitDetails(data);
  for (var key in benefit) {
    if (Object.prototype.hasOwnProperty.call(benefit, key)) {
      this[key] = benefit[key];
    }
  }
  this.componentPayments = _mapInstanceProperty(_context3 = data.componentPayments).call(_context3, function (payment) {
    return new ComponentPaymentDetails(payment);
  });
  this.deductions = _mapInstanceProperty(_context4 = data.deductions).call(_context4, function (payment) {
    return new DeductionDetails(payment);
  });
});
var PaymentDetails = /*#__PURE__*/_createClass(function PaymentDetails(data) {
  var _data$benefitPayments;
  _classCallCheck(this, PaymentDetails);
  this.amount = data.amount;
  this.status = data.status ? data.status : 'Not processed yet';
  this.benefitPayments = (_data$benefitPayments = data.benefitPayments) === null || _data$benefitPayments === void 0 ? void 0 : _mapInstanceProperty(_data$benefitPayments).call(_data$benefitPayments, function (payment) {
    return new BenefitPaymentDetails(payment);
  });
});
var NextPaymentDetails = /*#__PURE__*/_createClass(function NextPaymentDetails(data) {
  _classCallCheck(this, NextPaymentDetails);
  var payment = new PaymentDetails(data);
  for (var key in payment) {
    if (Object.prototype.hasOwnProperty.call(payment, key)) {
      this[key] = payment[key];
    }
  }
  this.isNextPayment = true;
  this.dueDate = data.dueDate;
  this.isAdjusted = data.isAdjusted;
  this.paymentTypes = data.paymentTypes;
});
var PreviousPaymentDetails = /*#__PURE__*/_createClass(function PreviousPaymentDetails(data) {
  _classCallCheck(this, PreviousPaymentDetails);
  var payment = new PaymentDetails(_Object$assign({}, data, {
    benefitPayments: groupComponentData(data.details)
  }));
  for (var key in payment) {
    if (Object.prototype.hasOwnProperty.call(payment, key)) {
      this[key] = payment[key];
    }
  }
  this.isNextPayment = false;
  this.paymentId = data.payment_id;
  this.paymentDate = data.paymentDate;
  this.coverStartDate = data.coverStartDate;
  this.coverEndDate = data.coverEndDate;
  this.payedByName = data.payedByName;
  this.nominatedPayeeName = data.nominatedPayeeName;
  this.nominatedPayeeAddress = data.nominatedPayeeAddress;
  this.checkNumber = data.checkNumber;
  this.voucherNumber = data.voucherNumber;
  this.bankSortCode = data.bankSortCode;
  this.bankAccountNumber = data.bankAccountNumber;
  this.external = data.external;
  this.method = data.method;
});
export default {
  NextPaymentDetails: NextPaymentDetails,
  PreviousPaymentDetails: PreviousPaymentDetails
};